import { Fields } from '@app/sharedModule/components/rules-dynamic-form/model';
import { RuleEntity, RuleOperator } from '@pdqdev/pdq-shared/dist/entities/Rules';

export const ConditionsRules = [
  {
    entity: RuleEntity.SKU,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
        {
          label: RuleOperator.CONTAINS,
          value: RuleOperator.CONTAINS,
        },
        {
          label: RuleOperator.NOT_CONTAINS,
          value: RuleOperator.NOT_CONTAINS,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'skuValue',
        defaultValue: '',
        operatorsSupportAutocompleteMode: [RuleOperator.IS_NOT, RuleOperator.IS],
        fieldType: Fields.INPUT,
      },
    ],
  },
  {
    entity: RuleEntity.PRODUCT_TAG,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
        {
          label: RuleOperator.CONTAINS,
          value: RuleOperator.CONTAINS,
        },
        {
          label: RuleOperator.NOT_CONTAINS,
          value: RuleOperator.NOT_CONTAINS,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'productTagValue',
        defaultValue: '',
        operatorsSupportAutocompleteMode: [RuleOperator.IS_NOT, RuleOperator.IS],
        fieldType: Fields.INPUT,
      },
    ],
  },
  {
    entity: RuleEntity.DELIVERY_AREA_ZIP_CODES,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'zipCodeValue',
        defaultValue: '',
        fieldType: Fields.INPUT,
        placeholder: 'Example: 10112, 10023, 10500-10550, U1K 2KK, L1H*',
      },
    ],
  },
  {
    entity: RuleEntity.DELIVERY_AREA_COUNTRIES,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'deliveryCountriesValue',
        defaultValue: '',
        operatorsSupportAutocompleteMode: [RuleOperator.IS_NOT, RuleOperator.IS],
        fieldType: Fields.INPUT,
      },
    ],
  },
  {
    entity: RuleEntity.DELIVERY_AREA_STATES,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'deliveryStatesValue',
        defaultValue: '',
        operatorsSupportAutocompleteMode: [RuleOperator.IS_NOT, RuleOperator.IS],
        fieldType: Fields.INPUT,
      },
    ],
  },
  {
    entity: RuleEntity.INVENTORY,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
      ],
    },
    entityParams: [
      {
        name: 'inventoryValue',
        defaultValue: 'out of stock',
        fieldType: Fields.TEXT,
      },
    ],
  },
];
